import { Injectable } from '@angular/core';

import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import {
  map,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from 'rxjs/operators';

import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';
import { IProduct } from '../interfaces/product';
import { IProducts } from '../interfaces/products';
import { IPackaging } from '../interfaces/packaging';
import { ISearch } from '../interfaces/search';
import { IOfertas } from '../interfaces/ofertas';
import { IOferta } from '../interfaces/oferta';
import { AppSettings } from '../appSettings';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private _apiService: ApiService) {}

  getPackaging(): Observable<IPackaging> {
    return this._apiService.doGET('packaging').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  search(arr: any): Observable<IProducts> {
    let urlParams = new HttpParams();
    for (let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString());
    }

    return this._apiService.doGET('products', urlParams).pipe(
      catchError((err) => {
        return observableThrowError(err.error_message);
      })
    );
  }

  searchProduct(title: Observable<string>, arr: any) {
    return title
      .pipe(debounceTime(400))
      .pipe(distinctUntilChanged())
      .pipe(
        switchMap((title) => {
          arr['search'] = title;
          return this.search(arr);
        })
      );
  }

  searchProducts(query: Observable<ISearch>) {
    return query
      .pipe(debounceTime(400))
      .pipe(distinctUntilChanged())
      .pipe(
        switchMap((query) => {
          return this.search(query);
        })
      );
  }

  /* old */
  findUsingCodbar(codbar: string): Observable<IProducts> {
    return this._apiService.doGET('product/codbar/' + codbar).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  /* retorna os produtos com o codigo de barra que iniciam com o valor enviado */
  getProductCodbar(codbar: string): Observable<IProduct> {
    return this._apiService.doGET('product/' + codbar + '/codbar').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getProductID(id: number): Observable<IProduct> {
    return this._apiService.doGET('product/' + id + '/id').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  findUsingId(id): Observable<IProduct> {
    return this._apiService.doGET('product/' + id).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  removeImage(
    codbarra,
    numero,
    idproduto,
    idestabelecimento
  ): Observable<IProduct> {
    return this._apiService
      .doPOST('product/' + codbarra + '/' + idproduto + '/image/' + numero, {
        idestabelecimento: idestabelecimento,
      })
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  store(data): Observable<IProduct> {
    return this._apiService.doPOST('products', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getOffers(id, arr: any): Observable<IOfertas> {
    let urlParams = new HttpParams();
    for (let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString());
    }
    return this._apiService.doGET(`product/${id}/offers`, urlParams).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeOffer(id, data): Observable<IOferta> {
    return this._apiService.doPOST(`product/${id}/offers`, data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  deleteOffer(id, i): Observable<any> {
    return this._apiService.doDELETE(`product/${id}/offers/${i}`).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getImportProducts(arr) {
    let urlParams = new HttpParams();
    for (let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString());
    }
    return this._apiService.doGET(`product/import`, urlParams).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getUrlImportProducts() {
    return {
      url: AppSettings.API_ENDPOINT + 'product/import',
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    };
  }
}
